import config from "../../../../config/config";
import React, { useState, useEffect } from 'react'; // Import useState and useEffect

const ExportControls = ({
  selectAll,
  onSelectAllChange,
  selectedCount,
  makeSelection,
  onExportCSV,
  onExportExcel,
  includeProductData,
  onIncludeProductDataChange,
  totalFilteredCount
}) => {
  // New state to manage the checkmark for "Make EMRD selection"
  const [emrdSelectionMade, setEmrdSelectionMade] = useState(false);
  // New states to manage the download icons for CSV and Excel
  const [csvDownloadStarted, setCsvDownloadStarted] = useState(false);
  const [excelDownloadStarted, setExcelDownloadStarted] = useState(false);

  // Use useEffect to reset the checkmarks when selectedCount changes
  useEffect(() => {
    setEmrdSelectionMade(false);
    setCsvDownloadStarted(false); // Reset CSV download icon
    setExcelDownloadStarted(false); // Reset Excel download icon
  }, [selectedCount]);

  // Modified onClick handler for "Make EMRD selection"
  const handleMakeSelectionClick = () => {
    makeSelection();
    setEmrdSelectionMade(true); // Set state to true after selection is made
  };

  // Modified onClick handler for CSV export
  const handleExportCSVClick = () => {
    onExportCSV();
    setCsvDownloadStarted(true); // Set state to true after CSV export starts
  };

  // Modified onClick handler for Excel export
  const handleExportExcelClick = () => {
    onExportExcel();
    setExcelDownloadStarted(true); // Set state to true after Excel export starts
  };

  return (
    <div className="selection-controls">
      <label className="select-all-label">
        <input
          type="checkbox"
          checked={selectAll}
          onChange={onSelectAllChange}
          disabled={totalFilteredCount === 0}
        /> Select all hits ({totalFilteredCount})
      </label>
      <div className="export-controls">
        <span className="export-label">
          Selected hits
          <span className="selection-count">{selectedCount}</span>:
        </span>
        <div className="export-buttons">
          <button className="export-button" onClick={handleMakeSelectionClick} disabled={selectedCount === 0}>
            {/* Conditional rendering for the icon */}
            <i className={emrdSelectionMade ? 'bx bx-check' : 'bx bx-copy'}></i> Make EMRD selection
          </button>
          <button className="export-button" onClick={() => { makeSelection(); window.location.href = config.routes.main.visualizations; }} disabled={selectedCount === 0}>
            <i className='bx bx-bar-chart'></i> Visualise
          </button>
          <span className="export-controls export-label">
            Export:
          </span>
          <button className="export-button" onClick={handleExportCSVClick} disabled={selectedCount === 0}>
            <i className={csvDownloadStarted ? 'bx bx-check' : 'bx bx-download'}></i> CSV
          </button>
          <button className="export-button" onClick={handleExportExcelClick} disabled={selectedCount === 0}>
            <i className={excelDownloadStarted ? 'bx bx-check' : 'bx bx-download'}></i> Excel
          </button>
        </div>
        <label className="include-product-data">
          <input
            type="checkbox"
            checked={includeProductData}
            disabled={selectedCount === 0}
            onChange={onIncludeProductDataChange}
          /> Include medicine data
        </label>

      </div>
    </div>
  );
};

export default ExportControls;